// Public API Keys
export const NEXT_PUBLIC_ANALYTICS_WRITE_KEY = process.env.NEXT_PUBLIC_ANALYTICS_WRITE_KEY || '';
export const NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_KEY =
  process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_KEY || '';

export const NEXT_PUBLIC_IPINFO_TOKEN = process.env.NEXT_PUBLIC_IPINFO_TOKEN || '';
export const NEXT_PUBLIC_AMPLITUDE_EXPERIMENTS_KEY =
  process.env.NEXT_PUBLIC_AMPLITUDE_EXPERIMENTS_KEY || '';
export const NEXT_PUBLIC_SEGMENT_CDN_DOMAIN = process.env.NEXT_PUBLIC_SEGMENT_CDN_DOMAIN || '';

// Firebase Configuration
export const NEXT_PUBLIC_FIREBASE_API_KEY =
  process.env.NEXT_PUBLIC_FIREBASE_API_KEY || 'fake-api-key';
export const NEXT_PUBLIC_FIREBASE_APP_ID = process.env.NEXT_PUBLIC_FIREBASE_APP_ID || 'fake-app-id';
export const NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN =
  process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || 'http://localhost:8082';
export const NEXT_PUBLIC_FIREBASE_DB_URL =
  process.env.NEXT_PUBLIC_FIREBASE_DB_URL || 'http://localhost:8080';
export const NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || '';
export const NEXT_PUBLIC_FIREBASE_MSG_SENDER_ID =
  process.env.NEXT_PUBLIC_FIREBASE_MSG_SENDER_ID || '';
export const NEXT_PUBLIC_FIREBASE_PROJECT_ID =
  process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || 'fake-project-id';
export const NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET =
  process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || '';
export const NEXT_PUBLIC_FIREBASE_HOSTING_URL =
  process.env.NEXT_PUBLIC_FIREBASE_HOSTING_URL || 'http://localhost:8000';
export const NEXT_PUBLIC_FUNCTIONS_URL =
  process.env.NEXT_PUBLIC_FUNCTIONS_URL ||
  `http://localhost:8083/${NEXT_PUBLIC_FIREBASE_PROJECT_ID}/us-central1`;

// Firebase Emulator Configuration
export const NEXT_PUBLIC_FIREBASE_USE_EMULATORS =
  process.env.NEXT_PUBLIC_FIREBASE_USE_EMULATORS || undefined;
export const STORAGE_EMULATOR_HOST = 'http://localhost:8085'; // Only used when using Firebase Emulators

// Firebase Service Account
export const FIREBASE_VERCEL_SERVICE_ACCOUNT_EMAIL =
  process.env.FIREBASE_VERCEL_SERVICE_ACCOUNT_EMAIL || '';
export const FIREBASE_VERCEL_PRIVATE_KEY = process.env.FIREBASE_VERCEL_PRIVATE_KEY || '';

// Stytch Connected Apps (OAuth consent page). All non-secret: public token + custom auth domain for
// the frontend SDK, the auth-service broker URL the consent page calls directly, and the trusted
// profile id the page passes to the SDK.
export const NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN = process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN || '';
export const NEXT_PUBLIC_STYTCH_CUSTOM_DOMAIN = process.env.NEXT_PUBLIC_STYTCH_CUSTOM_DOMAIN || '';
export const NEXT_PUBLIC_AUTH_API_BASE_URL =
  process.env.NEXT_PUBLIC_AUTH_API_BASE_URL || 'http://localhost:3813';
export const NEXT_PUBLIC_STYTCH_TRUSTED_PROFILE_ID =
  process.env.NEXT_PUBLIC_STYTCH_TRUSTED_PROFILE_ID || '';
// The Blinq Slack app's static Stytch client for this environment. Slack's OAuth callback is shared
// by every Slack app, so consent for a Slack-redirecting client is allowed only for this ID
// (CONNECTORS-ADR-003). Unset rejects every Slack client.
export const NEXT_PUBLIC_STYTCH_SLACK_CLIENT_ID = process.env.NEXT_PUBLIC_STYTCH_SLACK_CLIENT_ID || '';

// GraphQL APIs
export const NEXT_PUBLIC_GRAPHQL_API =
  process.env.NEXT_PUBLIC_GRAPHQL_API || 'http://localhost:8000/graphql';
export const NEXT_PUBLIC_GRAPHQL_WS_API =
  process.env.NEXT_PUBLIC_GRAPHQL_WS_API || 'ws://localhost:8000/graphql';

// URLs
export const NEXT_PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000';
export const NEXT_PUBLIC_PROXY_URL = process.env.NEXT_PUBLIC_PROXY_URL || 'http://localhost:8787/p';
export const NEXT_PUBLIC_BLINQ_FORWARD_BASE_URL =
  process.env.NEXT_PUBLIC_BLINQ_FORWARD_BASE_URL || 'http://localhost:8787/f';
export const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:8787';
export const NEXT_PUBLIC_DEEPLINK_BASE_URL = process.env.NEXT_PUBLIC_DEEPLINK_BASE_URL ?? '';
export const NEXT_PUBLIC_EMAIL_SIGNATURE_URL =
  process.env.NEXT_PUBLIC_EMAIL_SIGNATURE_URL || 'http://localhost:8787/e';
export const NEXT_PUBLIC_IMAGE_CDN_BASE_URL =
  process.env.NEXT_PUBLIC_IMAGE_CDN_BASE_URL || 'http://localhost:8081';
export const NEXT_PUBLIC_GOOGLE_WORKSPACE_APP_URL =
  process.env.NEXT_PUBLIC_GOOGLE_WORKSPACE_APP_URL || '';
export const NEXT_PUBLIC_GOOGLE_WORKSPACE_UNINSTALL_APP_URL =
  process.env.NEXT_PUBLIC_GOOGLE_WORKSPACE_UNINSTALL_APP_URL || '';
export const NEXT_PUBLIC_CF_ICONS_WORKER_URL = process.env.NEXT_PUBLIC_CF_ICONS_WORKER_URL || '';
export const NEXT_PUBLIC_DEEP_LINK_URL =
  process.env.NEXT_PUBLIC_DEEP_LINK_URL || 'https://dl.nonprod.blnq.xyz';

// Product IDs
export const NEXT_PUBLIC_BUSINESS_PRODUCT_ID = process.env.NEXT_PUBLIC_BUSINESS_PRODUCT_ID || '';
export const NEXT_PUBLIC_PREMIUM_PRODUCT_ID = process.env.NEXT_PUBLIC_PREMIUM_PRODUCT_ID || '';
export const NEXT_PUBLIC_DYNAMIC_TAX_RATE_ID = process.env.NEXT_PUBLIC_DYNAMIC_TAX_RATE_ID || '';

// Other Configuration
// eslint-disable-next-line no-restricted-syntax
export const NEXT_PUBLIC_RELEASE_VERSION =
  process.env.NEXT_PUBLIC_RELEASE_VERSION ||
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ||
  'development';
export const NEXT_PUBLIC_ZARAZ_DOMAIN = process.env.NEXT_PUBLIC_ZARAZ_DOMAIN || '';
export const NEXT_PUBLIC_APPLE_APP_ID = process.env.NEXT_PUBLIC_APPLE_APP_ID || '';

// Datadog Configuration
export const NEXT_PUBLIC_DATADOG_APP_ID = process.env.NEXT_PUBLIC_DATADOG_APP_ID || '';
export const NEXT_PUBLIC_DATADOG_CLIENT_TOKEN = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || '';
export const NEXT_PUBLIC_DATADOG_SITE = process.env.NEXT_PUBLIC_DATADOG_SITE || '';
export const NEXT_PUBLIC_DATADOG_SERVICE_NAME = process.env.NEXT_PUBLIC_DATADOG_SERVICE_NAME || '';

// Hubspot Configuration
export const HUBSPOT_BOOKING_SUBDOMAIN_US = process.env.HUBSPOT_BOOKING_SUBDOMAIN_US || '';
export const HUBSPOT_BOOKING_SUBDOMAIN_EU = process.env.HUBSPOT_BOOKING_SUBDOMAIN_EU || '';
export const HUBSPOT_BOOKING_SUBDOMAIN_APAC = process.env.HUBSPOT_BOOKING_SUBDOMAIN_APAC || '';
export const HUBSPOT_BOOKING_SUBDOMAIN_SMB_US = process.env.HUBSPOT_BOOKING_SUBDOMAIN_SMB_US || '';
export const HUBSPOT_BOOKING_SUBDOMAIN_SMB_EU = process.env.HUBSPOT_BOOKING_SUBDOMAIN_SMB_EU || '';

// Logo Dev API Keys - server side only
export const LOGO_DEV_API_KEY = process.env.LOGO_DEV_API_KEY || '';
export const LOGO_DEV_SEARCH_API_KEY = process.env.LOGO_DEV_SEARCH_API_KEY || '';

// Vercel Deployment Environments
export enum DeploymentEnvironment {
  Development, // Local development environment
  Preview, // Non-Main-branch Preview Environments
  NonProduction, // Main branch Preview Environment
  Production, // Production Environment
}

// Vercel deployment environment with awareness of the Non-Prod environment.
// Returns DeploymentEnvironment enum type.
// NOTE: USE THIS INSTEAD OF VERCEL_DEPLOYMENT_ENV
export const DEPLOYMENT_DOMAIN: DeploymentEnvironment = (() => {
  switch (process.env.NEXT_PUBLIC_DEPLOYMENT_DOMAIN) {
    case 'development':
      return DeploymentEnvironment.Development;

    case 'preview':
      return DeploymentEnvironment.Preview;

    case 'nonprod':
      return DeploymentEnvironment.NonProduction;

    case 'production':
      return DeploymentEnvironment.Production;

    default:
      return DeploymentEnvironment.Development;
  }
})();

// Warnings for missing environment variables
if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test') {
  if (!process.env.NEXT_PUBLIC_PROXY_URL) {
    console.warn('Variable is not injected properly', { NEXT_PUBLIC_PROXY_URL });
  }

  if (!process.env.NEXT_PUBLIC_BASE_URL) {
    console.warn('Variable is not injected properly', { NEXT_PUBLIC_BASE_URL });
  }

  if (!process.env.NEXT_PUBLIC_EMAIL_SIGNATURE_URL) {
    console.warn('Variable is not injected properly', { NEXT_PUBLIC_EMAIL_SIGNATURE_URL });
  }
}

export const NEXT_PUBLIC_GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

export const NEXT_PUBLIC_FACEBOOK_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID || '';

// Factors AI Configuration
export const NEXT_PUBLIC_FACTORS_AI_TOKEN = process.env.NEXT_PUBLIC_FACTORS_AI_TOKEN || '';